import { useState } from "react";
import Facturacion from "./Facturacion";
import FacturacionLayout from "./FacturacionLayout";
import ConfigUtils from "../../utils/Config";
import { ROLES } from "../../common/Constantes";
import { Alert, Snackbar } from "@mui/material";

const FacturacionWrapper = () => {
  const [ready, setReady] = useState(false);

  const userRole: number = ConfigUtils.getUserRole();

  return (
    userRole !== ROLES.SANITARIO ?
    <>
      {!ready && <Facturacion onReady={() => setReady(true)} />}
      {ready && <FacturacionLayout />}
    </> : 
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open>
      <Alert severity="warning" sx={{ width: '100%' }} >Usuario no autorizado</Alert>
    </Snackbar>
  );
};

export default FacturacionWrapper;